import { Link } from "react-router-dom";

import { Tetromino } from "@/components/Tetromino";
import { Masthead } from "@/components/Masthead";

export function NotFound() {
  return (
    <>
      <Masthead variant="page" />
      <main className="lattice flex min-h-[calc(100vh-64px)] flex-col items-center justify-center gap-6 px-6 text-center">
        <Tetromino type="Z" cell={26} title="Z piece" />
        <h1 className="text-[clamp(2.5rem,9vw,5rem)]">Misdrop</h1>
        <p className="max-w-[38ch] leading-relaxed">
          There is nothing at this address. Check the link, or head back to the site.
        </p>
        <Link to="/" className="btn">
          Back to the site
        </Link>
      </main>
    </>
  );
}
